export const defaultMessengers = {
  phone: {
    name: 'تماس تلفنی',
    type: 'telephonic',
    id: 1,
    title: 'تماس با شما در زمان نوبت',
    image: null,
    description: 'با توجه به<b> تماس تلفنی در زمان نوبت</b>، لطفا شماره موبایل کاربر انتخابی در دسترس باشد.',
  },
  whatsapp: {
    name: 'واتساپ',
    type: 'whatsapp',
    id: 2,
    title: 'تماس با شما در زمان نوبت',
    image: 'https://clinic-s3.paziresh24.com/icons/whatsapp.jpg',
    description: 'لطفا توجه داشته باشید ویزیت آنلاین از طریق <b>پیام رسان واتساپ</b> برای کاربر انتخابی شما انجام می شود.',
  },
  eitaa: {
    name: 'ایتا',
    type: 'eitaa',
    id: 3,
    title: 'تماس با شما در زمان نوبت',
    image: 'https://clinic-s3.paziresh24.com/icons/ita.jpg',
    description: 'لطفا توجه داشته باشید ویزیت آنلاین از طریق <b>پیام رسان ایتا </b> برای کاربر انتخابی شما انجام می شود.',
  },
};
